import { Input, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type ReactElement } from "react";
import { useController } from "react-hook-form";

interface Props {
  name: string;
  showLabel?: boolean;
}

export function EmailField(props: Props): ReactElement {
  const { name, showLabel = true } = props;
  const {
    field,
    fieldState: { error },
    formState: { isSubmitting },
  } = useController({
    name,
  });

  return (
    <Stack spacing={1}>
      {showLabel && (
        <Text
          semibold
          variant="body1"
          sx={{ color: (theme) => theme.palette.grey[700], paddingLeft: 1, paddingBottom: 2 }}
        >
          Enter your email address:
        </Text>
      )}
      <Input
        {...field}
        fullWidth
        type="email"
        inputProps={{
          "aria-label": "Email",
        }}
        placeholder="Enter your email address"
        disabled={isSubmitting}
        error={Boolean(error)}
        size="large"
        iconType="email-filled"
      />
      {error && (
        <Text variant="caption" color="error" sx={{ paddingLeft: 1 }}>
          {error.message}
        </Text>
      )}
    </Stack>
  );
}
